import React from "react"
import CheckoutTemplate from "components/templates/CheckoutTemplate"

export default function CheckoutPage() {
  return (
    <CheckoutTemplate/>
  )
}
